/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var XCircleIcon32Regular = forwardRef('XCircleIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M12.053 10.639a1 1 0 0 0-1.415 1.414L14.587 16l-3.947 3.947a1 1 0 0 0 1.414 1.415L16 17.413l3.947 3.947a1 1 0 0 0 1.415-1.414L17.413 16l3.947-3.947a1 1 0 0 0-1.414-1.415L16 14.587l-3.947-3.947Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13S23.18 3 16 3ZM5 16C5 9.925 9.925 5 16 5s11 4.925 11 11-4.925 11-11 11S5 22.075 5 16Z" })));
});
